__turbopack_context__.v({
  "caption": "FoodDetailComponent-module__ei30fa__caption",
  "content": "FoodDetailComponent-module__ei30fa__content",
  "foodTime": "FoodDetailComponent-module__ei30fa__foodTime",
  "full": "FoodDetailComponent-module__ei30fa__full",
  "header": "FoodDetailComponent-module__ei30fa__header",
  "lg": "FoodDetailComponent-module__ei30fa__lg",
  "lightBentoBox": "FoodDetailComponent-module__ei30fa__lightBentoBox",
  "progress": "FoodDetailComponent-module__ei30fa__progress",
  "progressBar": "FoodDetailComponent-module__ei30fa__progressBar",
  "root": "FoodDetailComponent-module__ei30fa__root" + " " + __turbopack_context__.i(768839)["sectionPadding"],
  "sm": "FoodDetailComponent-module__ei30fa__sm",
  "visualisationContainer": "FoodDetailComponent-module__ei30fa__visualisationContainer",
});
